import { useState, useEffect, useCallback } from 'react';
import { fetchNearbyPartners } from '../api/additionalServicesApi';
import { NearbyPartner } from '../types/additionalServiceTypes';
import { GeolocationCoords } from './useGeolocation';

interface NearbyPartnersState {
  partners: NearbyPartner[];
  loading: boolean;
  error: string | null;
}

export interface UseNearbyPartnersReturn extends NearbyPartnersState {
  reload: () => void;
}

export function useNearbyPartners(
  serviceId: number | null,
  coords: GeolocationCoords | null,
  radius?: number,
): UseNearbyPartnersReturn {
  const [state, setState] = useState<NearbyPartnersState>({
    partners: [],
    loading: false,
    error: null,
  });

  const load = useCallback(
    async (id: number, location: GeolocationCoords) => {
      setState({ partners: [], loading: true, error: null });
      try {
        const data = await fetchNearbyPartners(id, {
          latitude: location.latitude,
          longitude: location.longitude,
          radius,
        });
        setState({ partners: data, loading: false, error: null });
      } catch {
        setState({
          partners: [],
          loading: false,
          error: 'Não foi possível carregar os parceiros disponíveis',
        });
      }
    },
    [radius],
  );

  useEffect(() => {
    if (!serviceId || !coords) {
      setState({ partners: [], loading: false, error: null });
      return;
    }
    load(serviceId, coords);
  }, [serviceId, coords, load]);

  const reload = useCallback(() => {
    if (serviceId && coords) load(serviceId, coords);
  }, [serviceId, coords, load]);

  return { ...state, reload };
}
